module.exports = __webpack_public_path__ + "img/5-oneImg.a44d9b3f.png";